import _find from 'lodash/find';
import { createSelector } from 'reselect';
import { practitioners } from 'store/saga/entities/bound';
import { selectActiveVenueId, selectMsInventoryVenues, selectRouteParams } from 'selectors/general';

export const selectPractitionersEntity = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => {
    const { data, error, loaded, loading } = practitioners.select(state, venueId);
    return {
      data: loaded ? data : [],
      error,
      isLoading: loading,
      isLoaded: loaded,
    };
  }
);

export const selectPractitionersIsLoading = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => practitioners.loading(state, venueId)
);

export const selectPractitioners = createSelector(
  state => state || {},
  selectActiveVenueId,
  (state, venueId) => (practitioners.loaded(state, venueId) ? practitioners.data(state, venueId) : [])
);

export const selectSelectedPractitionerId = createSelector(selectRouteParams, params => params.itemId);

export const selectSelectedPractitioner = createSelector(
  selectPractitioners,
  selectSelectedPractitionerId,
  (prts, selectedId) => _find(prts, ({ id }) => id === Number(selectedId) || id === selectedId) || {}
);

export const selectPractitionerVenues = createSelector(
  selectMsInventoryVenues,
  selectSelectedPractitioner,
  (ven, { venueIds }) => (ven ? ven.filter(({ id }) => venueIds && venueIds.includes(id)) : [])
);
